const NODE_ENV = process.env.NODE_ENV;

let UPLOAD = 'https://www-api.86links.cn/cms/imgfiles2';
let GATEWAY = 'https://gateway-api.86links.cn';
let HOST_PREVIEW = 'https://landing.86links.cn/templates';
let BASEPOINT = 'https://base.86links.cn/point';

if (NODE_ENV === 'production') {
  UPLOAD = 'https://www-api.86links.com/cms/imgfiles2';
  GATEWAY = 'https://gateway-api.86links.com';
  HOST_PREVIEW = 'https://landing.86links.com/templates';
  BASEPOINT = 'https://base.86links.com/point';
}

export default {
  UPLOAD,
  GATEWAY,
  HOST_PREVIEW,
  BASEPOINT,
};
